// export default {
//   GREEN: '#90c926',
//   RED: '#ee5340',
//   GRAY: '#d0cccc',
//   BLACK: '#000',
//   YELLOW: '#f8bd00',
// };

export default {
  GREEN: 'green',
  RED: 'red',
  GRAY: 'gray',
  BLACK: 'black',
  YELLOW: 'yellow',
};
